import React from 'react';
import { Box, Divider, makeStyles } from '@material-ui/core';
import { DragDropContext, Droppable, OnDragEndResponder } from 'react-beautiful-dnd';
import { colors } from 'theme';
import DraggableListItem, { Item } from './DraggableListItem';

const useStyles = makeStyles({
  droppableContainer: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: colors.greyLightest,
  },
  droppablePart: {
    width: '49%',
    border: 'dashed 1px',
    borderColor: colors.neutralGray,
    borderRadius: '4px',
  },
  dropArea: {
    height: '100px',
    padding: '4px',
  },
});

export type DraggableListProps = {
  items: Item[];
  itemsRight: Item[];
  onDragEnd: OnDragEndResponder;
};

const DraggableList = React.memo(({ items, itemsRight, onDragEnd }: DraggableListProps) => {
  const classes = useStyles();
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Box className={classes.droppableContainer}>
        <Box className={classes.droppablePart}>
          <Droppable direction="horizontal" ignoreContainerClipping={false} droppableId="droppable-list">
            {provided => (
              <div ref={provided.innerRef} {...provided.droppableProps} className={classes.dropArea}>
                {items.map((item, index) => (
                  <DraggableListItem item={item} index={index} key={item.draggableId} />
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </Box>
        <Divider orientation="vertical" flexItem />
        <Box className={classes.droppablePart}>
          <Droppable direction="horizontal" ignoreContainerClipping={false} droppableId="droppable-list-2">
            {provided => (
              <div ref={provided.innerRef} {...provided.droppableProps} className={classes.dropArea}>
                {itemsRight.map((itemsRight, index) => (
                  <DraggableListItem item={itemsRight} index={index} key={itemsRight.draggableId} />
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </Box>
      </Box>
    </DragDropContext>
  );
});

export default DraggableList;
